import * as React from 'react';
import { ReactNode } from 'react';
import { Labelled, LabelledProps } from '../../components/form/Labelled';
import { UsersDTO } from '../../../api/admin';
import { UserSuggester } from './UserSuggester';


interface LabelledPublisherSuggesterProps extends LabelledProps {
  value: UsersDTO[];
  onChange: (refs: UsersDTO[]) => void;
  tooltip?: string;
  tooltipOptions?: any;
  pattern?: string;
  autoFocus?: boolean;
  className?: string;
  multiple: boolean;
  border?: 'border-noround' | 'border-noround-right';
}

export const LabelledUserSuggester = (props: LabelledPublisherSuggesterProps): ReactNode => {
  const disabled: boolean = (props.permissions ? !props.permissions.canWrite : false) || props.disabled;
  return (
    <Labelled {...props}>
      <UserSuggester
        value={props.value}
        autoFocus={props.autoFocus}
        inputId={props.id}
        required={props.permissions?.required || props.required}
        disabled={disabled}
        multiple={props.multiple}
        validation={props.validation}
        border={props.border}
        onChange={props.onChange}
      />
    </Labelled>
  );
};
